import React from 'react';
import { Table, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { AuthorCell, EntryTableActions, formatLogged } from './entryTable';
import type { ProgramFeedback } from '../../interfaces/CamProgramming.interface';

const { Text } = Typography;

interface FeedbackTableProps {
	entries: ProgramFeedback[];
	loading: boolean;
	onView: (entry: ProgramFeedback) => void;
	onEdit: (entry: ProgramFeedback) => void;
	onDelete: (entry: ProgramFeedback) => void;
}

/** Feedback as one row apiece, for reading the record rather than the prose. */
const FeedbackTable: React.FC<FeedbackTableProps> = ({
	entries,
	loading,
	onView,
	onEdit,
	onDelete,
}) => {
	const columns: ColumnsType<ProgramFeedback> = [
		{
			title: 'Author',
			key: 'author',
			render: (_, entry) => <AuthorCell user={entry.author} />,
		},
		{
			title: 'Logged',
			dataIndex: 'created_time',
			key: 'created_time',
			width: 190,
			render: (timestamp: string) => (
				<Text>{formatLogged(timestamp)}</Text>
			),
		},
		{
			title: '',
			key: 'actions',
			width: 170,
			align: 'right',
			render: (_, entry) => (
				<EntryTableActions
					onView={() => onView(entry)}
					onEdit={() => onEdit(entry)}
					onDelete={() => onDelete(entry)}
					deleteConfirmTitle="Remove this feedback?"
				/>
			),
		},
	];

	return (
		<Table
			className="cam-entry-table"
			size="small"
			rowKey="id"
			loading={loading}
			columns={columns}
			dataSource={entries}
			pagination={false}
			locale={{ emptyText: 'No feedback yet' }}
		/>
	);
};

export default FeedbackTable;
